var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarSquareDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10705_30136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.791016 2.32227H15.2094V15.2989H0.791016V2.32227Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.39453 0.160156V2.32289",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6055 0.160156V2.32289",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.791016 5.20605H15.2094",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.95312 8.4502H13.1131",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.95312 12.0557H9.11312",
    stroke: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10705_30136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSquareDefault);
export default __webpack_public_path__ + "static/media/calendar-square-default.80782828.svg";
export { ForwardRef as ReactComponent };